import { NgModule } from '@angular/core';
import { CrmWarningDialogComponent } from './crm-warning-dialog.component';
import { SiModalModule } from '../../../../../shared/components';
import { CrmWarningDialogService } from './crm-warning-dialog.service';

@NgModule({
    declarations: [CrmWarningDialogComponent],
    imports: [SiModalModule],
    providers: [CrmWarningDialogService],
})
export class CrmWarningDialogModule {}
